// DropdownContext.js
import React from "react";

const DropdownContext = React.createContext();

export default DropdownContext;
